import React, { useEffect, useState } from "react";
import { Form, Drawer, Select, Button, Alert, Divider } from "antd";

import SurgicalInterventionSummary from "../surgical_intervention/SurgicalInterventionSummary";

import moment from "moment";

const { Option } = Select;

const layout = {
  labelCol: {
    span: 7,
  },
  wrapperCol: {
    span: 16,
    className: "mx-3",
  },
};

const layoutSelect = {
  showSearch: true,
  allowClear: true,
  optionFilterProp: "children",
};

const SurgicalInterventionOutputTypeForm = (props) => {
  const { surgicalIntervention } = props;
  const [form] = Form.useForm();
  const [editable, setEditable] = useState(false);
  const [necessarySendMail, setNecessarySendMail] = useState(false);

  /**
   *
   * @param {*} start_at
   * @param {*} expected_end_at
   * @returns
   */
  const isEditable = () => {
    setEditable(!surgicalIntervention.end_at);
  }

  const onChange = (value) => {
    setNecessarySendMail(surgicalIntervention.output_type !== value);
  }

  const hasChanged = () => {
    let formValue = form.getFieldValue("output_type");
    return (surgicalIntervention.output_type !== formValue);
  }

  const onFinish = async () => {
    form.validateFields()
      .then(async (values) => {
        props.onUpdate(surgicalIntervention.id, values['output_type']);
        onClose();
      })
      .catch((errors) => { });
  };

  const onClose = () => {
    props.onClose();
    form.resetFields();
    setNecessarySendMail(false);
  };

  useEffect(() => {
    if (surgicalIntervention) {
      form.setFieldsValue({
        output_type: surgicalIntervention.output_type,
      });

      isEditable();
    }
  }, [surgicalIntervention]);

  if (!surgicalIntervention) {
    return null;
  }

  let warning = null;
  let endAlert = null;

  if (surgicalIntervention.end_at) {
    let endAt = moment(surgicalIntervention.end_at).format('DD/MM/YYYY');
    endAlert = <Alert message={"Cette intervention à fait l'objet d'une sortie le " + endAt} type="info" showIcon />;
  } else if (necessarySendMail) {
    warning = <Alert message={"Un mail sera renvoyé à l'assistante sociale pour confirmation"} type="info" showIcon />;
  }

  return (
    <Drawer
      width={800}
      title="Modification du mode de sortie"
      placement="left"
      visible={props.visible}
      onClose={onClose}
      footer={
        <div style={{ textAlign: "right" }}>
          <div>
            <Button onClick={onClose} style={{ marginRight: 8 }}>
              Annuler
            </Button>
            <Button
              onClick={onFinish}
              type="primary"
              disabled={!editable || !hasChanged()}
            >
              Enregistrer
            </Button>
          </div>
        </div>
      }
    >
      <SurgicalInterventionSummary surgicalIntervention={surgicalIntervention} />
      <Divider />
      <Form {...layout} form={form} className="my-2">
        <Form.Item label="Mode de sortie" name="output_type">
          <Select
            {...layoutSelect}
            allowClear={false}
            disabled={!editable}
            onChange={onChange}
          >
            <Option key={0} value={"home"}>Domicile</Option>
            <Option key={1} value={"convalescence"}>Convalescence</Option>
            <Option key={2} value={"had"}>H.A.D.</Option>
          </Select>
        </Form.Item>
        {warning}
      </Form>
      {endAlert}
    </Drawer>
  );
};

export default SurgicalInterventionOutputTypeForm;
